import { render, staticRenderFns } from "./OfficerTask.vue?vue&type=template&id=22021e3c"
import script from "./OfficerTask.vue?vue&type=script&lang=js"
export * from "./OfficerTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports